import {
    ApiClientFactory
} from '../ApiClientFactory';
import {
    API_URL
} from '../Variables';

let clientFactory = new ApiClientFactory();

export const SearchClient = {
    search(term) {
        return clientFactory.get(API_URL + 'search?term=' + term)
    }
};